import React from "react"
import Container from "@ecom/ui/components/Container"
import { Img } from "./Img"
import * as styles from "./card.module.scss"

const items: {
  title: string
  text: string
}[] = [
  {
    title: "7 млн. +",
    text: "клиентов",
  },
  {
    title: "до 24 мес",
    text: "рассрочки*",
  },
  {
    title: "> 250 000",
    text: "магазинов партнeров",
  },
  {
    title: "+30%",
    text: "к вашему чеку гарантированно",
  },
  {
    title: "до 50%",
    text: "больше новых клиентов",
  },
  {
    title: "+30%",
    text: "частота покупок",
  },
]

export const Card = () => (
  <section className={styles.section}>
    <Container className={styles.container}>
      <Img alt="card" className={styles.img} />
      <div className={styles.list}>
        {items.map(({ title, text }) => (
          <div className={styles.item}>
            <div className={styles.title}>{title}</div>
            <div className={styles.text}>{text}</div>
          </div>
        ))}
      </div>
    </Container>
  </section>
)
